import { createFileRoute } from "@tanstack/react-router";
import DealerPublicListings from "@/pages/DealerPublicListings";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dealeri/$alias/anunturi/")({
  head: ({ params }) => routeHead("/dealeri/$alias/anunturi/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerPublicListings />
  );
}
